import ChevronIcon from "assets/icons/ChevronIcon";
import { ReactNode, RefObject } from "react";
import styles from "./style.module.scss";
import classNames from "classnames";

const PulsingDropdownIcon = ({
  containerRef,
  showPulse,
  toggleDropdown,
  isDropdownOpen,
  children,
  showGreenPulse,
}: PulsingDropdownIconProps) => {
  const containerClassnames = classNames(styles.dropdownIconContainer, {
    [styles.greenIcon]: showGreenPulse,
  });

  return (
    <div
      ref={containerRef}
      className={containerClassnames}
      onClick={toggleDropdown}
    >
      {showPulse && <div className={styles.pulse}></div>}
      {isDropdownOpen ? (
        <ChevronIcon direction="up" />
      ) : (
        <ChevronIcon direction="down" />
      )}
      {isDropdownOpen && children}
    </div>
  );
};

export default PulsingDropdownIcon;

interface PulsingDropdownIconProps {
  showPulse: boolean;
  children?: ReactNode;
  isDropdownOpen: boolean;
  toggleDropdown: () => void;
  containerRef: RefObject<HTMLDivElement>;
  showGreenPulse?: boolean;
}
